import { SET_AUTH_STATUS, STORE_BEARER_TOKEN, AUTHENTICATE, UNAUTHENTICATE } from '../actions/types'

const authenticationReducer = function (state = {
  authenticated: false,
  bearerToken: false,
  authStatus: 'uninitiated'
}, action) {
  switch (action.type) {
    case AUTHENTICATE:
      return {
        ...state,
        authenticated: true
      }
    case SET_AUTH_STATUS:
      return {
        ...state,
        authStatus: action.authStatus
      }
    case UNAUTHENTICATE:
      return {
        ...state,
        authenticated: false,
        bearerToken: false
      }
    case STORE_BEARER_TOKEN:
      return {
        ...state,
        bearerToken: action.token
      }
    default:
      return state
  }
}
export default authenticationReducer



// WEBPACK FOOTER //
// /app/js/reducers/authenticationReducer.js